import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RbacService } from 'src/app/api-info/system-management-api';
import { ProcessRolesUsersViewModel } from 'src/app/api-info/system-management-api/model/processRolesUsersViewModel';

@Injectable({
  providedIn: 'root',
})
export class UserRoleService {
    userNo: string | undefined;
  constructor(
    private rbacService: RbacService
  ) {
    this.initAcknowledgeUsers();
  }

  acknowledgeUsers: string[] = [];
  isInit = false;

  /**
   * 初始化：將特定流程角色的使用者快取
   */
   initAcknowledgeUsers(): void {
    if (!this.isInit) {
      this.getAcknowledgeUserInfo().subscribe(userNos => {
        this.acknowledgeUsers = userNos;
        this.isInit = true;
      });
  
      this.rbacService.rbacAccountGet('Web').subscribe(user => {
        this.userNo = user?.userNo;
      });
  
      this.isInit = true;
    }
  }

  /**
   * 呼叫 OpenAPI client 取得流程角色的使用者資料
   */
  private getUserInfoByProcessRole(processRoleId: string): Observable<ProcessRolesUsersViewModel> {
    return this.rbacService.rbacProcessRolesProcessRoleIdGet(
      processRoleId,
      'Web', // X-From-Channel，可依需求修改
    );
  }

  /**
   * 查詢 AcknowledgeUsers 流程角色下所有 userNo
   */
  getAcknowledgeUserInfo(): Observable<string[]> {
    return this.getUserInfoByProcessRole('AcknowledgeUsers').pipe(
      map((res) => res?.users?.map(user => user.userNo).filter((u): u is string => !!u) || [])
    );
  }

  matchWordsReplace(value: string, replaceWords: { [key: string]: string }): string {
    const regex = new RegExp(Object.keys(replaceWords).join('|'), 'gi');
    return value.replace(regex, matched => {
      const replacement = replaceWords[matched.toLowerCase()];
      return replacement ? this.matchCasing(matched, replacement) : matched;
    });
  }

  matchCasing(source: string, target: string): string {
    if (source === source.toUpperCase()) {
      return target.toUpperCase();
    } else if (source[0] === source[0].toUpperCase()) {
      return target.charAt(0).toUpperCase() + target.slice(1).toLowerCase();
    } else {
      return target;
    }
  }

}

